import gql from 'graphql-tag'

/**
 * Query
 */
const STATE_ACTIVE = gql`
    query statesActive {
        statesActive {
            id
            name
            is_active
            cities {
                id
                name
                state_id
                districts {
                    id
                    name
                    city_id
                }
            }
        }
    }
`

/**
 * Mutations
 */

export {
    STATE_ACTIVE
}
